import getServiceToken from './ServiceAccountAccess';

const extractResults = (spreadSheetData, resultsTransformer) => {
    if (!(spreadSheetData.valueRanges && spreadSheetData.valueRanges[0].valueRange.values)) {
        return [];
    }

    return spreadSheetData
        .valueRanges
        .map((vr) => resultsTransformer(vr.valueRange.values));
};

export default async (sheetId, searchCriteria, resultsTransformer) => {
    const bearerToken = await getServiceToken();
    const response = await fetch(`https://sheets.googleapis.com/v4/spreadsheets/${sheetId}/values:batchGetByDataFilter`, {
        body: JSON.stringify(searchCriteria),
        headers: {
            Accept: 'application/json',
            Authorization: `Bearer ${bearerToken}`,
            'Content-type': 'application/json'
        },
        method: 'POST'
    });

    if (!response.ok) {
        throw new Error(response.statusText);
    }

    const json = await response.json();

    return extractResults(json, resultsTransformer);
};



// WEBPACK FOOTER //
// ./src/data/getRows.js